import { RequestFreightDetail } from 'TypeGen/Order/Load/request-freight-detail';
import { IDNameViewModel } from 'TypeGen/id-name-view-model';
import { formatNumber } from '@progress/kendo-intl';
import { InputSuffix, NumericTextBox } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Link, Typography } from '@mui/material';
import { FreightDetail } from 'TypeGen/Order/Load/freight-detail';

type Props = {
  weightUnitOfMeasure: IDNameViewModel[];
  data: FreightDetail;
  request: RequestFreightDetail;
  updateRequest: (request: Partial<RequestFreightDetail>) => void;
}

const WeightInput = ({ data, request, updateRequest, weightUnitOfMeasure }: Props) => {
  const weightUoM = (weightUoM: number) => weightUnitOfMeasure.find(x => x.ID === weightUoM)!.Name;
  return <>
    <NumericTextBox
      fillMode={'outline'}
      value={request.Weight > 0 ? request.Weight : null}
      placeholder="Weight"
      min={0}
      style={{ marginTop: '1rem' }}
      spinners={false}
      onChange={(e) => updateRequest({ Weight: e.value || 0 })}
      suffix={() => (
        <>
          <InputSuffix>
            <DropDownList
              data={weightUnitOfMeasure}
              textField="Name"
              dataItemKey="ID"
              value={weightUnitOfMeasure.find(x => x.ID === request.WeightUnitOfMeasure)}
              onChange={(e) => updateRequest({ WeightUnitOfMeasure: e.value?.ID || 0 })}
            />
          </InputSuffix>
        </>
      )}
    />
    <Typography
      variant="body2"
      color="textSecondary"
    >
      Requested <Link onClick={() => updateRequest({ Weight: data.Weight, WeightUnitOfMeasure: data.WeightUnitOfMeasure })}>{formatNumber(data.Weight, 'n0')} {weightUoM(data.WeightUnitOfMeasure)}</Link>
    </Typography>
  </>;
};

export default WeightInput;